import React from "react";
import "./App.css";
import "./index.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import About_Us from "./components/about-us/About_Us";
import Services from "./components/services/Services";
import Facility from "./components/facilities/Facility";
import Our_Clients from "./components/our-clients/Our_Clients";
import Blogs from "./components/blogs/Blogs";
import Contact_Us from "./components/contact_us/Contact_Us";
import Service_Detail from "./components/services/service-detail/Service_Detail";
import Detail_Blog from "./components/blogs/detail-blog/Detail_Blog";
import ScrollToTop from "./components/scroll-to-top/Scroll_to_Top";

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:id" element={<Service_Detail />} />
        <Route path="/facilities" element={<Facility />} />
        <Route path="/our-clients" element={<Our_Clients />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:id" element={<Detail_Blog />} />
        <Route path="/contact" element={<Contact_Us />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
